<template>
  <div
    class="goodsr_epurchase"
    style="min-width: 1086px"
    v-loading.fullscreen.lock="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <!-- 数据展示 -->
    <div class="main_content" v-if="!showTaskOfficial && !showEffectAnalysis">
      <div class="global-title">
        {{ tittle }}
      </div>
      <div style="padding-left: 28px; padding-top: 16px">
        <span style=""
          >基于大数据场景营销模型，对符合条件消费者人群进行营销每日循环营销。</span
        >
      </div>

      <div class="tab-line">
        <div
          class="tab-item"
          @click="handleSwitch(1)"
          :class="{ active: tabIndex == '1' }"
          :style="{
            color: tabIndex == '1' ? globalBG : '',
            'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '',
          }"
        >
          创建活动
          <span></span>
        </div>

        <div
          class="tab-item"
          @click="handleSwitch(2)"
          :class="{ active: tabIndex == '2' }"
          :style="{
            color: tabIndex == '2' ? globalBG : '',
            'border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',
          }"
        >
          任务列表
          <span></span>
        </div>

        <!-- end -->
      </div>

      <!-- 第一个模块 tab1 -->
      <div v-if="tabIndex == 1" class="grouping-container">
        <ul>
          <template v-for="(item, index) in officialListitem">
            <div
              class="classifyName systems"
              :key="index + '@'"
              v-if="officialListItemShow(item.list)"
            >
              <div>
                <span style="line-height: 24px">{{ item.classifyName }}</span>
                <span
                  style="
                    padding-left: 8px;
                    font-size: 12px;
                    color: #666;
                    line-height: 20px;
                  "
                  >{{ item.classifyDescription }}</span
                >
              </div>
              <!-- <span class="open" @click="handleOpenSystem(index)" v-show="item.list.length >= 5">{{ item.openSystem ? "展开" : "收起" }}</span> -->
            </div>
            <div class="tempList" :key="index + '?'">
              <template v-for="info in item.list">
                <li class="item-box" :key="info.type" v-if="info.show">
                  <div class="item">
                    <div class="headName">
                      <img class="i" :src="info.img" alt="" />

                      <div class="wrap-name">
                        <span class="name">{{ info.title }}</span>
                        <img :src="info.icon" v-if="info.icon" alt="" />
                      </div>
                    </div>
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover"
                      :content="info.desc"
                    >
                      <p class="desc" slot="reference">
                        {{ info.desc }}
                      </p>
                    </el-popover>

                    <div class="footBtn">
                      <p v-if="autoMarketingTaskListNum.length > 0">
                        <mark
                          style="background: none; font-size: 14px"
                          v-if="
                            autoMarketingTaskListNum.find((item) => {
                              return item.activityType == info.type;
                            }) &&
                            autoMarketingTaskListNum.find((item) => {
                              return item.activityType == info.type;
                            }).isCreated
                          "
                          >活动进行中：</mark
                        >
                        <mark
                          style="background: none; color: #999; font-size: 14px"
                          v-else
                          ><i class="el-icon-warning-outline"></i
                          >&nbsp;未创建</mark
                        >

                        <span
                          style="cursor: pointer; font-size: 24px"
                          @click="footBtnList(info)"
                          v-if="
                            autoMarketingTaskListNum.find((item) => {
                              return item.activityType == info.type;
                            }) &&
                            autoMarketingTaskListNum.find((item) => {
                              return item.activityType == info.type;
                            }).isCreated
                          "
                        >
                          {{
                            autoMarketingTaskListNum.find((item) => {
                              return item.activityType == info.type;
                            }).count
                          }}
                        </span>
                      </p>
                      <div class="btns">
                        <el-button class="yinxiao_button3" @click="newBtn(info)"
                          >创建任务</el-button
                        >
                      </div>
                    </div>
                  </div>
                </li>
              </template>
            </div>
          </template>
        </ul>
      </div>

      <!-- 第二个模块 tab2 -->
      <div v-if="tabIndex == 2" class="tab_item_box">
        <!-- 按钮 -->
        <div>
          <div class="right_allBtn">
            <span>活动类型:</span>
            <el-select
              v-model="search1.activityType"
              placeholder="请选择"
              style="width: 186px; margin-left: 8px; margin-right: 30px"
            >
              <el-option
                v-for="item in activityTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <span>开启状态:</span>
            <el-select
              v-model="search1.status"
              placeholder="请选择"
              style="width: 116px; margin-left: 8px"
            >
              <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-input
              v-model="search1.activityName"
              placeholder="请输入任务名称"
              style="width: 140px; margin: 0 5px 0 8px"
            ></el-input>
            <el-input
              v-model="search1.content"
              placeholder="请输入短信内容"
              style="width: 140px; margin: 0 16px 0 0"
            ></el-input>
            <el-button
              icon="el-icon-search"
              class="status_btn"
              :disabled="tableLoading"
              @click="handleSearch1"
              >查询</el-button
            >
            <el-button class="status_btn status_btn2" @click="resetBtn1"
              >重置</el-button
            >
            <el-button class="export" @click="exportAll">批量导出</el-button>
          </div>
        </div>
        <!-- 表格 -->
        <div class="clear-float">
          <el-table
            :data="tableList"
            style="width: 100%; margin-top: 22px"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            v-loading="tableLoading"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column
              type="selection"
              width="55"
              v-model="tableList.id"
              :selectable="checkT"
            >
            </el-table-column>
            <el-table-column
              prop="activityName"
              label="任务名称"
              min-width="130"
            ></el-table-column>
            <el-table-column
              prop="activityType"
              label="活动类型"
              min-width="160"
            >
              <template slot-scope="scope">
                <!-- <span>{{
                  activityTypeList.find((item) => {
                    return item.value == scope.row.activityType;}).label
                }}</span> -->
                <span v-for="item in activityTypeList" :key="item.label"
                  ><span v-if="item.value == scope.row.activityType">{{
                    item.label
                  }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="content" label="短信内容" min-width="200">
              <template slot="header" slot-scope="scope">
                <span>短信内容</span>
                <span
                  style="color: #7f85e9"
                  @click="allShow = true"
                  v-if="!allShow"
                  >（展开全部）</span
                >
                <span style="color: #7f85e9" @click="allShow = false" v-else
                  >（收起全部）</span
                >
              </template>
              <template slot-scope="scope">
                <div class="hoveTitle" v-if="!allShow">
                  {{ scope.row.content | enVToChinese }}
                </div>
                <div v-else>{{ scope.row.content | enVToChinese }}</div>
              </template>
            </el-table-column>
            <el-table-column label="任务时间" width="320">
              <template slot-scope="scope">
                <span
                  >{{ scope.row.activityStartTime }} ~
                  {{ scope.row.activityEndTime }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="taskStatus" label="任务状态" width="100">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.activityStatus | showStatusName }}
                  <el-tooltip
                    class="item"
                    v-if="scope.row.activityStatus == 4"
                    effect="light"
                    :content="scope.row.stopReason"
                    placement="top-start"
                  >
                    <span class="question_icon">?</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="sendNum"
              label="已发送人数"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="feeCount"
              label="短信量"
              width="80"
            ></el-table-column>
            <el-table-column label="操作" width="450">
              <template slot-scope="scope">
                <!-- <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
                <el-button type="text" @click="delteItem(scope.row)" :style="{'color':'#f56c6c'}">删除</el-button>-->
                <el-button
                  v-zoom="{ from: pageName + tittle, name: '查看' }"
                  @click="catchOrderCare(scope.row)"
                  type="text"
                  class="edit_btn"
                  style="width: 40px"
                  >查看</el-button
                >

                <el-button
                  v-zoom="{ from: pageName + tittle, name: '效果分析' }"
                  @click="handleEffect(scope.row)"
                  type="text"
                  class="edit_btn"
                  style="width: 65px"
                  :disabled="scope.row.taskCount === 0"
                  >效果分析</el-button
                >
                <el-button
                  v-zoom="{ from: pageName + tittle, name: '营销记录' }"
                  @click="handleMarketingRecord(scope.row)"
                  type="text"
                  class="edit_btn"
                  style="width: 65px"
                  :disabled="scope.row.activityStatus == 1"
                  >营销记录</el-button
                >
                <el-button
                  v-if="scope.row.activityType == 14"
                  @click="handleDongRecord(scope.row)"
                  type="text"
                  class="edit_btn"
                  style="width: 90px;"
                  >咚咚消息记录</el-button
                >
                <el-button
                  @click="handlecopon(scope.row)"
                  type="text"
                  class="edit_btn"
                  >复制</el-button
                >
                <el-button
                  v-zoom="{ from: pageName + tittle, name: '停止' }"
                  @click="stopOrderCare(scope.row)"
                  :disabled="
                    !(
                      scope.row.activityStatus == 1 ||
                      scope.row.activityStatus == 2
                    )
                  "
                  type="text"
                  class="del_btn"
                  style="width: 40px"
                  >停止</el-button
                >
                <el-button
                  v-zoom="{ from: pageName + tittle, name: '删除' }"
                  @click="deleteOrderCare(scope.row)"
                  type="text"
                  :disabled="
                    !(
                      scope.row.activityStatus == 3 ||
                      scope.row.activityStatus == 4
                    )
                  "
                  class="del_btn"
                  style="width: 40px"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            background
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search1.current"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="search1.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="taskTableTotalCount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 营销记录弹窗 -->
    <market-record-dialog
      v-if="visible"
      :propId="propId"
      :propActivityStartTime="propActivityStartTime"
      @onClose="closeRecordDialog"
      :isAutoMarketOfficalModule="true"
    ></market-record-dialog>

    <!-- 效果分析页面 -->
    <effect-analysis
      v-if="showEffectAnalysis"
      :officialObj="officialObj"
      @onClose="handleCloseEffect"
      :isAutoMarketOfficalModule="true"
    ></effect-analysis>

    <!-- 创建活动 -->
    <create-task-official
      @onClose="handleCloseTask"
      v-if="showTaskOfficial"
      :activityType="activityType"
      :detailObj="detailObj"
      :copyIsfaly="copyIsfaly"
      :isPeriod="isPeriod"
    ></create-task-official>

    <!-- 批量导出 -->
    <generate
      :control="control"
      v-if="control"
      @transData="(val) => (control = val)"
      :flags= 'flags'
    ></generate>

    <!-- 咚咚消息记录弹窗 -->
    <dongdongMsgRecord
      v-if="isShowDongRecord"
      :propId="propId"
      :propActivityStartTime="propActivityStartTime"
      @onClose="closeDongRecord"
      :isAutoMarketOfficalModule="true"
    ></dongdongMsgRecord>

    <!-- 批量导出弹窗 -->
    <el-dialog title="统计时间" width="650px" :visible.sync="staVisible">
      <el-form>
        <el-form-item label="效果数据时间">
          <el-select style="width: 100px;" v-model="staValue" @change="staValueChange">
            <el-option
              v-for="(item, index) in statiType"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <template v-if="staValue == ''">
            <el-select style="margin: 0 10px; width: 110px;" v-model="timeType">
              <el-option label="相对时间" :value="1"></el-option>
              <el-option label="绝对时间" :value="2"></el-option>
            </el-select>
            <el-input
              style="width: 160px;"
              v-model="customValue"
              @keyup.native="customValue = limitInput($event)"
              v-if="timeType == 1"
            >
              <template slot="suffix"> 天 </template>
            </el-input>
            <div class="my_select_time" v-else>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="startTime"
                type="datetime"
                :placeholder="'开始时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
                :picker-options="startTimeOption"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="endTime"
                type="datetime"
                :placeholder="'结束时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
                :picker-options="endTimeOption"
                default-time="23:59:59"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearEffectTime()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
          </template>
        </el-form-item>
        <el-form-item label="添加备注" style="margin-left:18px">
          <el-input
            show-word-limit
            maxlength="20"
            type="textarea"
            :rows="3"
            style="width:220px; margin-left: 10px"
            v-model="customValue1"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <button class="cancel" @click="staVisible = false">取消</button>
        <button class="confirm" @click="batchUpload">确定</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import topTitle from "@/components/top-title.vue";
import Pagination from "@/components/pagination.vue";
import marketRecordDialog from "@/components/marketing-record-dialog.vue";
// import pageCondition from "./autoMarket/page-condition.vue";
// import sendMessageX from "@/components/send-message-x.vue";
import {
  getActivityList,
  deleteMarket,
  stopActivity,
  catchActivity,
  queryTaskNum,
  getSeller,
  intelligentExport,
  exportMarketing,
} from "@/api/marketing/autoMarketingO";
import {
  exportPopCommentSmsEffect,
  exportNotpayremind,
} from "@/api/care/orderCare";
import effectAnalysis from "@/components/effect-analysis-x.vue";
import createTaskOfficial from "@/components/create-task-official.vue";
// import pageConditionX from "@/components/page-condition-x.vue";
import generate from "../../components/generate_report.vue";
import dongdongMsgRecord from "@/components/dongdong-msg-record.vue";

export default {
  components: {
    topTitle,
    Pagination,
    // pageCondition,
    marketRecordDialog,
    // sendMessageX,
    effectAnalysis,
    createTaskOfficial,
    // pageConditionX
    generate,
    dongdongMsgRecord,
  },
  data() {
    return {
      timeType: 1,
      flags:0,
      customValue1:'',
      // 点击确定时的loading效果
      loading: false,
      // 自动化营销模型(官方)-任务时间
      activityStartTime: "",
      activityEndTime: "",
      // 弹窗-时间默认近7天
      staValue: "7",
      // 批量下载弹窗时间 近7天/近15天/近30天/自定义
      customValue: "",
      // 点击批量导出按钮-弹窗效果数据时间：
      startTime: "", // 统计开始时间
      endTime: "", // 统计结束时间
      startTimeOption: {
        disabledDate: (date) => {
          let endTime = this.endTime;
          let time = date.getTime();
          let isDisabled = false;
          if (endTime) {
            isDisabled = time + 24 * 60 * 60 * 1000 >= new Date(endTime).getTime();
          }
          return isDisabled;
        },
      },
      endTimeOption: {
        disabledDate: (date) => {
          let startTime = this.startTime;
          let time = date.getTime();
          let isDisabled = false;
          if (startTime) {
            isDisabled = time <= new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
          }
          return isDisabled;
        },
      },
      statiType: [
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
        {
          label: "自定义",
          value: "",
        },
      ],
      // 批量导出弹窗
      staVisible: false,
      // 批量导出
      control: false,
      multipleSelection: [], // 表格多选
      copyIsfaly: false,
      pageName: "客户营销-自动化营销（官方）",
      officialObj: {}, // 效果分析传参
      detailObj: {},
      propId: "", // 营销记录id
      showEffectAnalysis: false,
      selectEffectObj: {},
      typeEffect: 4,

      selectIndex: 1,
      tableState: true,
      tableLoading: false,
      talbeLoading1: false,
      allShow: false, // 信息是否全部显示
      smsTableTotalCount: 0,
      taskTableTotalCount: 10,
      // topPX: "60px",
      // bodyHeight: 0,
      // detailFormData: null, // 编辑任务获取详情数据
      // pageConditionCom: false, //编辑新建任务组件
      search1: {
        content: "",
        status: "",
        activityName: "",
        size: 10,
        current: 1,
        activityType: "",
      },
      // 首购有礼查询条件
      smsSearchParams: {
        sendStartTime: "", //发送开始时间
        sendEndTime: "", //发送结束时间
        // comfrom: "", //信息来由
        buyerNick: "", //买家昵称
        mobile: "", //手机号码
        status: "", //发送状态 0未发送 1已发送 2黑名单失败 4(10分钟内容重复) 3过滤重复发送 5无效号码 6中差评拦截 7退款拦截 ,
        tid: "", //订单编号
        // softType: "1", //1(订单关怀,掌柜预警) 2(会员营销)
        content: "", //短信内容
        pageNum: 1, //当前页
        pageSize: 10, //每页大小
        total: "",
      },

      // 表格数据
      smsTableList: [],
      tableList: [],
      /**
       * 主页记录分页信息
       */
      paginationInfo: {
        tableCurrentPage: 1,
        pageSize: 10,
        totalCount: 100,
      },
      crowdTotal: 10,
      visible: false,
      showTaskOfficial: false,

      tabIndex: 1,
      nowTime:"",

      activityType: "",
      // 创建活动列表
      officialListObject: "",
      officialListitem: [],
      //创建活动列表-数量
      autoMarketingTaskListNum: [],
      // 发送状态
      stateList: [
        {
          value: "",
          label: "-全部-",
        },
        {
          value: "1",
          label: "未开始",
        },
        {
          value: "2",
          label: "进行中",
        },
        {
          value: "3",
          label: "已结束",
        },
        {
          value: "4",
          label: "已停止",
        },
      ],
      //活动类型
      activityTypeList: [
        {
          value: "",
          label: "-全部-",
        },
        {
          value: 1,
          label: "首购有礼",
        },
        {
          value: 2,
          label: "复购有礼",
        },
        {
          value: 3,
          label: "流失客户召回",
        },
        {
          value: 4,
          label: "兴趣客户转化",
        },
        {
          value: 5,
          label: "开卡未购会员转化",
        },
        {
          value: 6,
          label: "已购客户开卡转化",
        },
        {
          value: 14,
          label: "商品复购",
        },
        {
          value: 7,
          label: "直播提醒",
        },
        {
          value: 8,
          label: "店铺上新提醒",
        },
        {
          value: 9,
          label: "会员专享活动提醒",
        },
        {
          value: 10,
          label: "会员积分使用提醒",
        },
        {
          value: 15,
          label: "会员生日提醒",
        },
        {
          value: 11,
          label: "沉默会员召回-行业活跃",
        },
        {
          value: 12,
          label: "店铺预售高潜人群关怀",
        },
        {
          value: 13,
          label: "算法大促高转化人群营销",
        },
        {
          value: 16,
          label: "会员日营销",
        },
        {
          value: 17,
          label: "京享值用户兴趣转化",
        },
        {
          value: 18,
          label: "京东plus会员营销",
        },
        {
          value: 19,
          label: "储值卡用户提醒",
        },
      ],
      // 当前活跃行的开始时间
      propActivityStartTime: '',
      isPeriod:false,//是否显示商品复购
      permissionsArr: '',
      isShowDongRecord: false,//是否显示咚咚消息记录
    };
  },

  watch: {
    timeType(nVal) {
      if (nVal == 1) {
        this.clearEffectTime()
      } else {
        this.customValue = ""
      }
    }
  },

  created() {
    // 埋点
    this.buriedPoint(1, "自动化营销模型", "客户营销", "自动化营销(官方)");
  },
  mounted() {
    console.log(this.copyIsfaly, 66666);
    this.getSellerFun();
    this.handleSearch();
    this.getqueryTaskNum();

    //效果分析新tab页
    if (
      this.$route.query.outerId &&
      this.$route.query.source &&
      this.$route.query.activityEndTime &&
      this.$route.query.activityStartTime
    ) {
      this.handleSwitch(2);
      this.officialObj = {
        outerId: this.$route.query.outerId,
        source: this.$route.query.source,
        activityEndTime: this.$route.query.activityEndTime,
        activityStartTime: this.$route.query.activityStartTime,
      };
      this.showEffectAnalysis = true;
    }
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),

    // 获取定义在路由meta的信息
    tittle() {
      return "自动化营销模型";
    },
    desc() {
      return this.$route.meta.desc;
    },
    MenuIndex() {
      return this.$route.meta.itemIndex;
    },
  },
  filters: {
    showStatusName(status) {
      var res = "";
      if (status) {
        var list = ["", "未开始", "进行中", "已结束", "已停止"];
        res = list[status];
      }
      return res;
    },

    statusStr(status) {
      return {
        0: "未发送",
        1: "已发送",
        2: "黑名单失败",
        4: "10分钟内容重复",
        3: "过滤重复发送",
        5: "无效号码",
        6: "中差评拦截",
        7: "退款拦截",
      }[status];
    },
  },
  methods: {
    staValueChange(val) {
      if (val) {
        this.customValue = ""
        this.clearEffectTime()
      }
    },

    // 清除效果数据时间
    clearEffectTime() {
      this.startTime = ""
      this.endTime = ""
    },

    // 生成报表按钮
    batchUpload() {
      var dayNum = this.staValue;
      if (this.staValue === "") {
        dayNum = this.customValue;
        // if (this.customValue >= 30) {
        //   dayNum = 30;
        // }
        if (!dayNum && this.timeType == 1) {
          this.$message.warning("请输入天数！");
          return;
        }
        if (this.timeType == 2 && !this.startTime) {
          this.$message.warning("请选择开始时间！");
          return;
        }
        if (this.timeType == 2 && !this.endTime) {
          this.$message.warning("请选择结束时间！");
          return;
        }
      }
      this.loading = true;
      let arr = [];
      this.multipleSelection.forEach((item) => {
        arr.push(item.id);
      });
      let ids = "";
      ids = arr.join(",");
      let arrA = {
        dayNum: dayNum,
        preActivityIds: ids,
        source: 5,
        exportRemark:this.customValue1,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      let paramStr = "";
      for (var key in arrA) {
        let temp = "&" + key + "=" + arrA[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);

      exportMarketing(paramStr).then((res) => {
        if (res.code == 1) {
          this.staVisible = false;
          this.control = true;
          this.flags = 1
        } else {
          this.$message.error(res.data);
        }
        this.loading = false;
      });
      this.loading = false;
    },
    // 批量导出弹窗时间选择
    limitInput(event) {
      var value = event.target.value;
      if (value == "0") {
        event.target.value = "";
        // } else if (value >= 30) {
        // event.target.value = 30;
      } else {
        event.target.value = value.replace(/[^\d]/g, "");
      }
      return event.target.value
    },
    // 监听表格多选事件
    handleSelectionChange(val) {
      // console.log(val);
      this.multipleSelection = val;
    },
    // 批量导出
    exportAll() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请勾选营销任务");
        return;
      } else {
        // this.control=true;
        this.staVisible = true;
      }
    },
    footBtnList(item) {
      console.log("item", item);
      this.officialListObject = item;
      this.search1.activityType = item.type;
      this.tabIndex = 2;
      this.handleSearch1();
    },
    getSellerFun() {
      getSeller().then((res) => {
        const permissions = res.data.permissions || [];
        this.permissionsArr = permissions
        console.log(permissions, "permissions");
        this.isPeriod = permissions.indexOf("ware:period") > -1
        this.officialListitem = [
          {
            classifyName: "客户生命周期模型",
            classifyDescription: "",
            type: 1,
            list: [
              {
                title: "开卡未购会员转化",
                desc: "针对开卡入会一定时间后未购买的客户进行主动营销，提升转化率",
                icon: require("@/assets/images/auto_marketing_official/hot.png"),
                img: require("@/assets/images/auto_marketing_official/开卡未购会员转化.png"),
                show:
                  permissions.indexOf("conversion:unpurchased:members") > -1,
                type: 5,
              },
              {
                title: "已购客户开卡转化",
                desc: "对已购未入会的店铺新客户进行会员招募，提高店铺会员量",
                icon: require("@/assets/images/auto_marketing_official/hot.png"),
                img: require("@/assets/images/auto_marketing_official/已购客户开卡转化.png"),
                show: permissions.indexOf("conversion:purchased:members") > -1,
                type: 6,
              },
              {
                title: "首购有礼",
                desc: "对首次在店铺成交的客户发送关怀，或者推送搭配商品，引导复购",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/首购有礼.png"),
                show: permissions.indexOf("first:purchase:official") > -1,
                type: 1,
              },
              {
                title: "复购有礼",
                desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/首购有礼.png"),
                show: permissions.indexOf("reminder:purchase:official") > -1,
                type: 2,
              },
              {
                title: "兴趣客户转化",
                desc: "近期有加购或者关注但无成交的客户持续转化",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/兴趣客户转化.png"),
                show: permissions.indexOf("interest:customer:conversion") > -1,
                type: 4,
              },
              {
                title: "流失客户召回",
                desc: "客户超过180天未成交，自动发送关怀，唤醒客户记忆进店购买",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/流失客户召回.png"),
                show: permissions.indexOf("call:customer:churn") > -1,
                type: 3,
              },
              {
                title: "商品复购",
                desc: "根据商品的消耗周期，在商品即将消耗完的时候发送提醒，引导复购",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/商品复购.png"),
                show: permissions.indexOf("ware:period") > -1,
                type: 14,
              },
            ],
          },
          {
            classifyName: "日常运营",
            classifyDescription: "",
            type: 2,
            list: [
              {
                title: "直播提醒",
                desc: "对有直播下单偏好的客户进行开播提醒，提升直播间观看量",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/直播提醒.png"),
                show: permissions.indexOf("live:remind") > -1,
                type: 7,
              },
              {
                title: "店铺上新提醒",
                desc: "根据客户近一年，对有新品购买偏好的客户进行上新提醒，打造店铺新爆款",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/店铺上新提醒.png"),
                show: permissions.indexOf("shop:new:remind") > -1,
                type: 8,
              },
              {
                title: "会员专享活动提醒",
                desc: "对高价值的店铺会员，进行活动提醒",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/会员专享活动提醒.png"),
                show:
                  permissions.indexOf("member:exclusive:activity:remind") > -1,
                type: 9,
              },
              {
                title: "会员积分使用提醒",
                desc: "提醒会员使用积分，提升会员价值",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/会员积分使用提醒.png"),
                show: permissions.indexOf("member:point:use:remind") > -1,
                type: 10,
              },
              {
                title: "会员生日提醒",
                desc: "对临近生日的店铺会员，进行活动提醒",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/会员生日提醒.png"),
                show: permissions.indexOf("member:birthday") > -1,
                type: 15,
              },
              {
                title: "会员日营销",
                desc: "每月固定会员日，向会员发送店铺优惠信息，提升会员参与度。",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/会员日营销.png"),
                show: permissions.indexOf("member:day:marketing") > -1,
                type: 16,
              },
              {
                title: "京享值用户兴趣转化",
                desc: "对京享值用户进行定向营销，提高店铺销量",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/京享值用户兴趣转化.png"),
                show: permissions.indexOf("jxz:member:interest") > -1,
                type: 17,
              },
              {
                title: "京东plus会员营销",
                desc: "对高价值的京东plus会员进行营销，触达重点用户",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/京东plus会员营销.png"),
                show: permissions.indexOf("plus:member:marketing") > -1,
                type: 18,
              },
              {
                title: "储值卡用户提醒",
                desc: "筛选有储值卡充值行为的人群进行营销，可及时进行消费/复充提醒",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/储值用户提醒.png"),
                show: permissions.indexOf("rechargeAmountCard:member:remind") > -1,
                type: 19,
              },
            ],
          },
          {
            classifyName: "大促营销",
            classifyDescription: "",
            type: 3,
            list: [
              {
                title: "沉默会员召回-行业活跃",
                desc: "会员在商家店铺沉默，大促附近期间有在同行业近期有下单、浏览、加购行为的",
                icon: require("@/assets/images/auto_marketing_official/hot.png"),
                img: require("@/assets/images/auto_marketing_official/沉默会员召回-行业活跃.png"),
                show: permissions.indexOf("silence:member:recall") > -1,
                type: 11,
              },
              {
                title: "店铺预售高潜人群关怀",
                desc: "对店铺预售具有较高购买潜力的人群进行营销触达",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/店铺预售高潜人群关怀.png"),
                show:
                  permissions.indexOf("shop:presall:high:potential:crowd") > -1,
                type: 12,
              },
              {
                title: "算法大促高转化人群营销",
                desc: "对大促期间高转化购买人群进行营销触达",
                icon: "",
                img: require("@/assets/images/auto_marketing_official/算法大促高转化人群营销.png"),
                show:
                  permissions.indexOf("algorithm:high:transform:corwd") > -1,
                type: 13,
              },
            ],
          },
        ];
      });
    },
    // 将回传的列表数据显示为已勾选
    checkT(row, index) {
      if (row.taskCount == 0) {
        return false;
      } else {
        return true;
      }
    },
    officialListItemShow(arr) {
      let a = false;
      arr.forEach((i) => {
        if (i.show == true) {
          a = true;
        }
      });
      return a;
    },

    // table切换
    handleSwitch(index) {
      this.tabIndex = index;
      if (index == 1) {
        this.getSellerFun();
        this.getqueryTaskNum();
      }
    },
    //活动进行中数
    getqueryTaskNum() {
      queryTaskNum().then((res) => {
        if (res.code == "1") {
          // this.$message.success("删除成功！");
          // this.handleSearch();
          this.autoMarketingTaskListNum = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //----------------分割线------------------------------
    //----------------分割线------------------------------
    //----------------分割线------------------------------
    //----------------分割线------------------------------
    //----------------分割线------------------------------
    //----------------分割线------------------------------
    //----------------分割线------------------------------
    //----------------分割线------------------------------

    handlecopon(row) {
      console.log("row", row);
      if(this.checkVersion(row.activityType)) {
        catchActivity(row.id).then((res) => {
          this.detailObj = {
            ...res.data,
            activityEndTime: "",
            activityStartTime: "",
          };
          this.activityType = res.data.activityType;
          this.showTaskOfficial = true;
          this.copyIsfaly = true;
        });
      }else {
        this.$message.error("当前版本不符，无法复制，如需创建请联系您的商务")
      }
      
      // this.copyItem = item;
    },
    checkVersion(index) {
      let permissionsArr = this.permissionsArr;
      let permissionsObj = {
        1: permissionsArr.indexOf("first:purchase:official") > -1,
        2: permissionsArr.indexOf("reminder:purchase:official") > -1,
        3: permissionsArr.indexOf("call:customer:churn") > -1,
        4: permissionsArr.indexOf("interest:customer:conversion") > -1,
        5: permissionsArr.indexOf("conversion:unpurchased:members") > -1,
        6: permissionsArr.indexOf("conversion:purchased:members") > -1,
        7: permissionsArr.indexOf("live:remind") > -1,
        8: permissionsArr.indexOf("shop:new:remind") > -1,
        9: permissionsArr.indexOf("member:exclusive:activity:remind") > -1,
        10: permissionsArr.indexOf("member:point:use:remind") > -1,
        11: permissionsArr.indexOf("silence:member:recall") > -1,
        12: permissionsArr.indexOf("shop:presall:high:potential:crowd") > -1,
        13: permissionsArr.indexOf("algorithm:high:transform:corwd") > -1,
        14: permissionsArr.indexOf("ware:period") > -1,
        15: permissionsArr.indexOf("member:birthday") > -1,
        16: permissionsArr.indexOf("member:day:marketing") > -1,
        17: permissionsArr.indexOf("jxz:member:interest") > -1,
        18: permissionsArr.indexOf("plus:member:marketing") > -1,
        19: permissionsArr.indexOf("rechargeAmountCard:member:remind") > -1,
      }
      return permissionsObj[index];
    },
    handleSizeChange(val) {
      this.search1.size = val;
      this.search1.current = 1;

      this.handleSearch();
    },

    handleCurrentChange(val) {
      this.search1.current = val;
      this.handleSearch();
    },
    handleCloseTask(val) {
      this.showTaskOfficial = false;
      if (val && val.refresh) {
        console.log("val", val);
        console.log(this.officialListObject);
        this.search1.activityType = this.officialListObject.type;
        this.tabIndex = 2;
        this.handleSearch();
        this.getqueryTaskNum();
      }
    },
    // 查看按钮
    catchOrderCare(row) {
      catchActivity(row.id).then((res) => {
        this.detailObj = res.data;
        this.activityType = res.data.activityType;
        this.showTaskOfficial = true;
        this.copyIsfaly = false;
      });
    },
    handleCloseEffect() {
      this.showEffectAnalysis = false;
    },
    // 查询接口
    handleSearch() {
      this.tableLoading = true;
      // this.search1.activityType = '';
      getActivityList(this.search1).then((res) => {
        this.tableLoading = false;
        this.tableList = res.data.records;
        // this.tableList = [
        //   {
        //     id: 111,
        //     sellerNick: '测试测试',
        //     jdSmsSuffix: "测试",
        //     activityType: 16,
        //     content: "短信测试测试",
        //     createTime: "2023-12-07 17:35:32",
        //     activityStatus: 4,
        //     activityStartTime: "2023-12-07 17:35:32",
        //     activityEndTime: "2024-02-07 17:35:32",
        //   }
        // ];
        this.taskTableTotalCount = res.data.total;
        this.tableList.map((item) => {
          if (item.activityType) {
            let arr = this.activityTypeList.find((val) => {
              console.log(val.value , item.activityType);
              return val.value == item.activityType;
            });
            console.log(arr,'===============>');
          }

        });
      });
    },
    handleSearch1() {
      this.search1.current = 1;
      this.handleSearch();
    },
    // 停止活动
    stopOrderCare(row) {
      this.$confirm("你是否确认停止执行这项任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          stopActivity(row.id).then((res) => {
            if (res.code == "1") {
              this.$message.success("停止成功！");
              this.handleSearch();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // this.$message.info("已取消停止");
        });
    },
    // 删除活动
    deleteOrderCare(row) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          var fid = row.id;
          deleteMarket(fid).then((res) => {
            if (res.code == "1") {
              this.$message.success("删除成功！");
              this.handleSearch();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    closeRecordDialog() {
      console.log("closeRecordDialog");
      this.visible = false;
    },
    handleMarketingRecord(row) {
      // 营销记录记录弹窗
      console.log(row,'444444');
      this.propId = row.id + "";
      this.propActivityStartTime = row.activityStartTime;
      this.visible = true;
    },
    // 咚咚消息记录弹窗相关
    handleDongRecord(row) {
      this.propId = row.id + "";
      this.propActivityStartTime = row.activityStartTime;
      this.isShowDongRecord = true;
    },
    closeDongRecord() {
      this.isShowDongRecord = false;
    },
    handleEffect(row) {
      // 跳转营销效果分析页面
      // row.activityEndTime = row.activityEndTime.split(" ")[0];
      // row.activityStartTime = row.activityStartTime.split(" ")[0];
      // console.log(row);
      // return
      // this.selectEffectObj = row;

      // this.officialObj = {
      //   outerId: row.id,
      //   source: "AUTO_MARKETING",
      //   activityEndTime: row.activityEndTime.split(" ")[0],
      //   activityStartTime: row.activityStartTime.split(" ")[0],
      // };
      // this.showEffectAnalysis = true;

      let routeUrl = this.$router.resolve({
        path: "/marketing/auto_marketing_official/auto_market_official_module",
        query: {
          outerId: row.id,
          source: "AUTO_MARKETING",
          activityEndTime: row.activityEndTime.split(" ")[0],
          activityStartTime: row.activityStartTime.split(" ")[0],
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    smsPaginationFunction(event) {
      this.smsSearchParams.pageNum = event.current;
      this.smsSearchParams.pageSize = event.pageSize;
      this.getMessageRecord();
    },
    clearTime() {
      this.smsSearchParams.sendStartTime = "";
      this.smsSearchParams.sendEndTime = "";
    },
    resetBtn1() {
      this.search1 = {
        content: "",
        activityName: "",
        status: "",
        size: 10,
        current: 1,
        activityType: "",
      };
      this.handleSearch();
    },
    newBtn(item) {
      console.log("newBtn", item);
      this.activityType = item.type;
      this.officialListObject = item;
      this.detailObj = {};
      this.showTaskOfficial = true;
      this.copyIsfaly = false;

      // 埋点
      this.buriedPoint(1, item.title, "客户营销", "自动化营销(官方)");
    },
  },
};
</script>

<style lang="scss" scoped>
.export {
  float: right;
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #e67474 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #e67474;
  font-size: 12px !important;
  font-weight: normal !important;
}
.is-disabled.el-button {
  color: #ddd !important;
}

.main_content {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
  margin: 20px;

  .right_allBtn {
    // float: right;
    // margin-right: 28px;
    color: #333;
    font-size: 14px;
  }
  .tab_item_box {
    padding: 20px 25px 30px;
    .status_btn {
      font-size: 14px;
      width: 98px;
      font-size: 14px;
      height: 32px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .status_btn2 {
      margin-left: 8px;
      color: #666666;
      font-size: 14px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .search_item {
      display: inline-block;
      margin-right: 79px;
      margin-bottom: 16px;
      color: #333;
    }
  }
  .edit_btn {
    color: #7f85e9;
    font-size: 14px;
    width: 38px;
    padding: 0px !important;
    border: 0px;
    height: 20px;
    line-height: 20px;
    margin-left: 0;
    // margin-right: 20px;
  }
  .del_btn {
    font-size: 14px;
    padding: 0px !important;
    border: 0px;
    height: 20px;
    line-height: 20px;
    color: #fe4d45;
    margin-left: 0px;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 18px;
}
</style>

<style scoped lang="scss">
.tab-line {
  font-size: 14px;
  color: #666666;
  border-bottom: 1px solid #dddddd;
  margin: 24px 28px 0 28px;

  .tab-item {
    // padding: 15px 0;
    text-align: center;
    width: 106px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin-right: 2px;
    border: 1px solid #dddddd;
    border-bottom: none;

    span {
      position: absolute;
      width: 100%;
      left: 50%;
      height: 2px;
      transform: translateX(-50%);
      bottom: -2px;
      display: none;
    }
    &.active {
      border-top: 2px;
      span {
        display: block;
        background: #fff;
      }
    }
  }
}

.classifyName {
  display: block;
  position: relative;
  font-size: 14px;
  padding: 10px 10px 10px 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fafafa;
  margin-top: 15px;
  color: #333;
  min-height: 40px;
  &::after {
    content: "";
    position: absolute;
    left: 6px;
    display: block;
    background: #fe4d45;
    height: 14px;
    width: 3px;
    border-radius: 3px;
    top: 15px;
  }
  .open {
    color: #fe4d45;
    font-size: 14px;
    cursor: pointer;
  }
}

.grouping-container {
  min-width: 1080px;
  box-sizing: border-box;
  padding: 10px 28px 60px;
  .tempList {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 20px;
    overflow: hidden;
    transition: all 0.4s linear;
    .item-box {
      width: 25%;
      padding: 0 8px;
      @media screen and (max-width: 1540px) {
        padding: 0 6px;
      }
      margin-bottom: 20px;
      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
        position: relative;
        padding: 16px 32px;
        @media screen and (max-width: 1760px) {
          padding: 16px 14px 10px 14px;
        }
        @media screen and (max-width: 1540px) {
          padding: 16px 10px 16px 10px;
        }
        min-height: 180px;
        border: 1px solid rgba(238, 238, 238, 1);
        border-radius: 4px;
        .headName {
          display: inline-flex;
          align-items: center;
          width: 100%;
          .wrap-name {
            width: 100%;
            img {
              position: absolute;
              top: -5px;
              right: -7px;
            }
          }
          .i {
            width: 46px;
            height: 46px;
            margin-right: 16px;
            border-radius: 50%;
            opacity: 1;
          }
          .name {
            color: #333;
            font-size: 16px;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .desc {
          color: #666;
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          @media screen and (max-width: 1760px) {
            margin-top: 16px;
          }
        }
        .footBtn {
          display: flex;
          // align-items: flex-end;
          align-items: center;
          justify-content: space-between;
          @media screen and (max-width: 1760px) {
            padding-top: 10px;
          }
          @media screen and (max-width: 1540px) {
            padding-top: 10px;
          }
          p {
            color: #999;
            font-size: 14px;
            line-height: 20px;
            display: inline-flex;
            align-items: center;
            margin-top: 10px;
            @media screen and (max-width: 1760px) {
              font-size: 22px;
            }
            @media screen and (max-width: 1540px) {
              font-size: 20px;
            }
            font-weight: 500;
            span {
              color: #fe4d45;
              font-size: 24px;
              font-weight: 400;
            }
          }
          .btns {
            text-align: center;
            @media screen and (max-width: 1740px) {
              width: 90px;
              // height: 28px;
            }
            .renqun_button1 {
              width: 98px;
              height: 32px;
              color: #666666;
              border: 1px solid #dddddd;
              background-color: #fff;
            }
            .renqun_button1:hover {
              color: #fe4d45;
              border: 1px solid #fe4d45;
              background-color: #fff4f4;
            }
            .yinxiao_button2 {
              width: 92px;
              height: 30px;
              margin-top: 10px;
              @media screen and (max-width: 1760px) {
                width: 90px;
                height: 30px;
                margin: 6px 0 0 0 !important;
              }
              @media screen and (max-width: 1540px) {
                width: 84px;
                height: 28px;
                margin: 6px 0 0 0 !important;
              }
              color: #fe4d45;
              border: 1px solid #fe4d45;
              background-color: #fff;
            }
            .yinxiao_button3 {
              width: 98px;
              height: 32px;
              @media screen and (max-width: 1760px) {
                width: 90px;
                height: 30px;
                margin: 6px 0 0 0 !important;
              }
              @media screen and (max-width: 1540px) {
                width: 84px;
                height: 28px;
                margin: 6px 0 0 0 !important;
              }
              margin-top: 10px;
              // color: rgb(221, 221, 221);
              // border: 1px solid rgb(221, 221, 221);
              background-color: #fff;
              border: 1px solid #fe4d45;
              color: #fe4d45;
            }
            .yinxiao_button4 {
              width: 98px;
              height: 32px;
              @media screen and (max-width: 1760px) {
                width: 90px;
                height: 30px;
                margin: 6px 0 0 0 !important;
              }
              @media screen and (max-width: 1540px) {
                width: 84px;
                height: 28px;
                margin: 6px 0 0 0 !important;
              }
              margin-top: 10px;
              color: #999;
              border: 1px solid #ccc;
              background-color: #fff;
            }
            .yinxiao_button4:hover {
              border-color: #fe4d45;
              color: #fe4d45;
              background-color: #fff6f6;
            }
            .yinxiao_button2:hover {
              color: #ffffff;
              background-color: #fe4d45;
            }
            .yinxiao_button3:hover {
              border: 1px solid rgb(221, 221, 221);
              color: #fe4d45;
            }
          }
        }
      }
      &:nth-child(4n + 1) {
        padding: 0 8px 0 0;
        @media screen and (max-width: 1540px) {
          padding: 0 6px 0 0;
        }
      }
      &:nth-child(4n) {
        padding: 0 0 0 8px;
        @media screen and (max-width: 1540px) {
          padding: 0 0 0 6px;
        }
      }
      p {
        margin: 0;
      }
    }
    &.check {
      max-height: 100%;
    }

    .imgpath {
      max-height: 33px;
      position: absolute;
      right: 0;
      top: -1px;
    }
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;

  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }

  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;

    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .confirm {
    color: #ffffff;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}
</style>
